import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { Button } from '../Button/Button.js';
import { Icon } from '../Icon/Icon.js';
import S from './Expand.styl.js';

function Expand(props) {
    const { className, size = 'm', header, headerClassName, content, contentProps = {}, isOpen: initialOpen = false, onChange, } = props;
    const [isOpen, setIsOpen] = useState(initialOpen);
    const onHeaderClick = useCallback(() => {
        const value = !isOpen;
        setIsOpen(value);
        onChange?.(value);
    }, [isOpen]);
    useEffect(() => {
        setIsOpen(initialOpen);
    }, [initialOpen]);
    return (jsxs("div", { className: cn(S.root, isOpen && S.isOpen, className), children: [jsxs(Button, { variant: "clear", className: cn(S.header, headerClassName), size: size, onClick: onHeaderClick, children: [header, "\u00A0", jsx(Icon, { type: "chevronRight", size: size, className: S.headerIcon })] }), isOpen &&
                // @ts-ignore
                (content?.(contentProps) || jsx("div", { ...contentProps, children: content }))] }));
}

export { Expand };
